import { createFileRoute } from "@tanstack/react-router";

import { UnmatchedView } from "@/components/zotero-sync/UnmatchedView";

export const Route = createFileRoute("/zotero/unmatched")({
  component: UnmatchedPage,
});

function UnmatchedPage() {
  return (
    <div className="mx-auto max-w-2xl space-y-3 p-6">
      <h2 className="text-lg font-medium">Zotero — unmatched items</h2>
      <UnmatchedView />
    </div>
  );
}
